<div class="step-container">
  <div class="logo-hero">
    <div class="logo-hero-circle" (click)="abrirDialogFoto()">
      <div class="logo-hero-img" *ngIf="logoPreview">
        <img [src]="'/images/empresa/' + logoPreview" alt="Logo">
      </div>
      <div class="logo-hero-iniciais" *ngIf="!logoPreview">
        {{ iniciais || '?' }}
      </div>
      <div class="logo-hero-edit">
        <i class="fa fa-camera"></i>
      </div>
    </div>
    <span class="logo-hero-link" (click)="abrirDialogFoto()">
      {{ logoPreview ? 'Trocar logo' : 'Adicionar logo' }} <i class="fe-edit-2 ml-1"></i>
    </span>
  </div>

  <kendo-dialog *ngIf="abrirUpload"
                title="Foto da loja"
                [minWidth]="320"
                [width]="400"
                (close)="fecharDialogFoto()">

    <!-- Estado preview: mostra logo atual com ações claras -->
    <div class="logo-dialog" *ngIf="dialogState === 'preview'">
      <div class="logo-dialog-circle">
        <img [src]="'/images/empresa/' + logoPreview" alt="Logo atual">
      </div>
      <p class="logo-dialog-desc">Esta foto aparece no topo do seu cardápio digital para os clientes.</p>
      <div class="logo-dialog-actions">
        <button class="btn-trocar-foto" (click)="entrarModoUpload()">
          <i class="fe-camera"></i> Trocar foto
        </button>
        <button class="btn-remover-foto" (click)="removerFoto()">
          <i class="fe-trash-2"></i> Remover foto
        </button>
      </div>
    </div>

    <!-- Estado upload: formulário de upload -->
    <div class="logo-dialog" *ngIf="dialogState === 'upload'">
      <p class="logo-dialog-desc">Envie uma imagem quadrada com pelo menos 300×300px. Formatos: JPG ou PNG.</p>
      <app-upload-crop-imagem
        [objeto]="empresaParaUpload"
        ratio="1"
        [minHeight]="200"
        [minWidth]="200"
        [widthExibir]="320"
        [uploadUrl]="'/upload/imagem/logoempresa'"
        [prop]="'logo'"
        [label]="''"
        [maiorPossivel]="true"
        (onEnviou)="salveLogoEmpresa($event)">
      </app-upload-crop-imagem>
      <button class="btn-voltar-preview" *ngIf="logoPreview" (click)="dialogState = 'preview'">
        <i class="fe-arrow-left"></i> Voltar
      </button>
    </div>

  </kendo-dialog>

  <h2 class="step-titulo">{{ titulo }}</h2>
  <p class="step-subtitulo">{{ subtitulo }}</p>

  <div class="form-group mb-4">
    <label class="campo-label" for="nomeEmpresa">Nome da sua loja</label>
    <input type="text" class="campo-input" id="nomeEmpresa"
           [(ngModel)]="nome" placeholder="Ex: Pizzaria do Mario"
           [class.campo-shake]="shakeNome"
           (ngModelChange)="onNomeChange()"
           (keyup.enter)="avancar()">
  </div>

  <div class="mb-4">
    <label class="campo-label">
      Qual o segmento?
      <span class="campo-opcional" *ngIf="!segmentoObrigatorio">Opcional</span>
    </label>
    <div class="segmentos-grid" [class.campo-shake]="shakeSegmento">
      <div class="segmento-card"
           *ngFor="let seg of segmentos"
           [class.selecionado]="segmentoSelecionado === seg.nome"
           (click)="selecioneSegmento(seg.nome)">
        <div class="segmento-indicador" *ngIf="segmentoSelecionado === seg.nome">
          <i class="fe-check"></i>
        </div>
        <div class="segmento-icone" [ngClass]="classeCorSegmento(seg.nome)">
          <img class="segmento-imagem"
               [src]="seg.imagem"
               [alt]="seg.alt"
               loading="lazy"
               decoding="async">
        </div>
        <span>{{ seg.nome }}</span>
      </div>
    </div>
  </div>

  <div class="step-actions">
    <button class="btn-anterior" (click)="onVoltar.emit()">
      <i class="fe-arrow-left mr-1"></i> Anterior
    </button>
    <div class="d-flex flex-column align-items-end">
      <p class="text-danger mb-1" *ngIf="erroValidacao">
        <i class="fe-alert-circle mr-1"></i> {{ erroValidacao }}
      </p>
      <button class="btn-proximo" (click)="avancar()">
        Próximo <i class="fe-arrow-right ml-1"></i>
      </button>
    </div>
  </div>
</div>
